import type { ReactNode } from "react";
import { Brand } from "../brand";

/** A single card in the middle of the page, for screens outside the shell. */
export function Centered({ children }: { children: ReactNode }) {
	return (
		<main className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-surface p-4">
			<Brand />
			<div className="grid w-full max-w-sm gap-4">{children}</div>
		</main>
	);
}
